import React from 'react';
import { Flex } from '@chakra-ui/layout';
import { Tag, TagLabel, TagLeftIcon } from '@chakra-ui/tag';
import SharedExperienceIcon from './icons/sharedExperienceIcon';
import { Tooltip } from '@chakra-ui/react';
const SharedExperienceTag = ({ sharedExperienceName, size = 'sm' }) => {
  return (
    <Tooltip label={`Shared Experience: ${sharedExperienceName}`}>
      <Tag
        variant="green"
        border="none"
        size={size}
      >
        <TagLeftIcon boxSize='12px' as={SharedExperienceIcon} />
        <TagLabel>{sharedExperienceName}</TagLabel>
      </Tag>
    </Tooltip>
  );
};
export default SharedExperienceTag; 